import { useMemo } from 'react';

import { useEmployerUserContactData } from './use-employer-user-info-query';
import { COLLABORATOR_ROLE_KEYS } from '../components';

export function useIsEmployerAnAdmin() {
  const employerUserContactData = useEmployerUserContactData();
  return useMemo(
    () => employerUserContactData?.role_rw_key === COLLABORATOR_ROLE_KEYS.ADMIN,
    [employerUserContactData?.role_rw_key]
  );
}
